import './LabelHeader.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Barcode } from '..';
import IMAGES from '../../assets/images';

class LabelHeader extends Component {
    render() {
        const { partNumber, totalParts, part, barcodeEnabled, renderPartCount = true } = this.props;
        return (
            <div className={'LabelHeader'}>
                <img className={'LabelLogo'} src={IMAGES.logos.SPEEDlabel} alt={'SPEEDlabel'} />
                {barcodeEnabled &&
                    <div className={'BarcodeContainer'}>
                        <Barcode value={part.id} />
                    </div>
                }
                {renderPartCount &&
                    <div className={'PartCount'}>Part {partNumber < 100 ? ` ${partNumber}` : partNumber} of {totalParts < 100 ? `${totalParts}` : totalParts}</div>
                }
            </div>
        );
    }
}

LabelHeader.defaultProps = {
    partNumber: 0,
    totalParts: 0,
    barcodeEnabled: undefined,
    part: {},
    renderPartCount: true
};

LabelHeader.propTypes = {
    partNumber: PropTypes.number,
    totalParts: PropTypes.number,
    barcodeEnabled: PropTypes.bool,
    part: PropTypes.shape(),
    renderPartCount: PropTypes.bool
};

export default LabelHeader;